<template>
	<div id="page-user-edit">
		<bread-crumbs
			v-if="activeTab === 0"
			:title="$t('Permissions.Permissions')"
			:subTitle="$t('general.SubtitlePermissions')"
			:sizeTitle="30"
			:lineHeightTitle="37"
			:sizeSubTitle="15"
			:lineHeightSubTitle="18"
		>
		</bread-crumbs>
		<div :class="activeTab === 0 ? 'vx-card p-4' : ''">
			<div v-if="activeTab === 0" class="tab-text">
				<permissions-list-view
					@selectedPermissionEmit="selectedPermission"
					@valueCreatePermission="valueCreatePermissionEmit"
				/>
			</div>
			<div v-else-if="activeTab === 1" class="tab-text">
				<template>
					<bread-crumbs
						class="ml-1"
						:title="editable ? $t('Permissions.UpdateLabel') : $t('Permissions.CreateLabel')"
						:subTitle="
							editable
								? $t('Permissions.FormTitlePermissionEdit')
								: $t('Permissions.FormTitlePermissionCreate')
						"
						:sizeTitle="22"
						:lineHeightTitle="27"
						:sizeSubTitle="13"
						:lineHeightSubTitle="16"
					>
					</bread-crumbs>
					<div class="vx-row mb-2">
						<div class="vx-col w-full flex items-center">
							<feather-icon
								class="g-breadcrumb--title"
								icon="ChevronLeftIcon"
								svgClasses="h-8 w-8"
								@click.prevent="valueCreatePermissionEmit(0)"
							/>
							<vs-breadcrumb
								class="g-breadcrumb--title"
								separator=""
								:items="[{title: $t('general.Return')}]"
								@click.prevent="valueCreatePermissionEmit(0)"
							></vs-breadcrumb>
						</div>
					</div>
				</template>
				<permissions-form
					:permission="permission"
					:editable="editable"
					@clearPermissionEmit="clearPermission"
					@updatePermissionsEmit="updatePermissions"
					@cancelEditEmit="cancelEdit"
					@valueCreatePermission="valueCreatePermissionEmit"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import PermissionsForm from "./PermissionsForm.vue";
import PermissionsListView from "./PermissionsListView.vue";
import Permission from "@/models/Permission.js";
//Modulo import
import modulePermissions from "@/store/permissions/modulePermissions.js";

export default {
	name: "Permissions",
	data() {
		return {
			permission: new Permission({}),
			activeTab: 0,
			editable: false,
		};
	},
	components: {
		PermissionsForm,
		PermissionsListView,
	},
	methods: {
		// Limpiar permiso
		clearPermission() {
			this.permission = new Permission({});
		},
		// Actualizar permisos en el state
		updatePermissions() {
			this.$vs.loading();
			this.$store
				.dispatch("modulePermissions/getPermissions")
				.then((res) => {
					this.$vs.loading.close();
					this.updateRole_Permission();
				})
				.catch((err) => {
					this.$vs.loading.close();
					this.$vs.notify({
						color: "danger",
						title: this.$t("Permissions.GetPermissions.TitleError"),
						text: this.$t("Permissions.GetPermissions.TextError"),
					});
					throw new Error(err);
				});
		},
		// Actualizar los permisos en el state
		updateRole_Permission() {
			this.$vs.loading();
			this.$store
				.dispatch("modulePermissions/getRolePermission")
				.then((res) => {
					this.$vs.loading.close();
				})
				.catch((err) => {
					this.$vs.loading.close();
					this.$vs.notify({
						color: "danger",
						title: this.$t("Permissions.GetRole_Permission.TitleError"),
						text: this.$t("Permissions.GetRole_Permission.TextError"),
					});
					throw new Error(err);
				});
		},
		// Permiso seleccionado en el componente PermissionList
		selectedPermission(permission) {
			this.permission = new Permission(permission);
			this.activeTab = 1;
			this.editable = true;
		},
		// Cancelar edición
		cancelEdit() {
			this.editable = false;
			this.activeTab = 0;
		},
		valueCreatePermissionEmit(val) {
			this.activeTab = val;
			if (this.activeTab === 0) {
				this.permission = new Permission({});
				this.editable = false;
			}
		},
	},
	created() {
		// Registrar modulo
		if (!modulePermissions.isRegistered) {
			this.$store.registerModule("modulePermissions", modulePermissions);
			modulePermissions.isRegistered = true;
		}
		// Consultar roles
		this.updatePermissions();
	},
};
</script>

<style></style>
